import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { Navigate, Outlet } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import AuthContext from "../../context/AuthContext";

const ProtectedRoute = () => {
  const { isLoggedIn, isAuthResolved } = useContext(AuthContext);

  if (!isAuthResolved) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size="large" />
      </div>
    );
  }

  return isLoggedIn ? (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Outlet />
    </>
  ) : (
    <Navigate to="/" />
  );
};

export default ProtectedRoute;
